import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalPaper: {
    display: 'flex',
    flexDirection: 'column',

    outline: 'none',
    backgroundColor: 'white',
    padding: 15,
    borderRadius: 10,
    maxWidth: 550,
    width: '90%',
    maxHeight: '90%',
  },
  modalHeader: {
    display: 'flex',
  },
  modalHeaderSide: {
    display: 'flex',
    flex: 1,
    flexShrink: 1,
    minWidth: 58,
  },
  modalClose: {
    width: 58,
    height: 58,
  },
  modalHeaderCenter: {
    display: 'flex',
    flex: 3,
    flexShrink: 3,
  },
  modalInputs: {
    marginTop: 25,
    display: 'flex',
  },
  modalCloseContainer: {
    justifyContent: 'flex-end',
  },
  textFieldBorders: {
    margin: '0 7px',
  },
  saveButton: {
    marginTop: 15,
    alignSelf: 'flex-end',
  },
}));
